export function generateCss() {
  const num = [];
  for (let i = 1; i < 1000; i++) {
    num.push(`tr:nth-child(${i}){
          animation-delay: ${i * 0.06}s !important;
        }`);
  }

  return num.join(' ');
}

// const GENAI_REQ_ALLOWED_BOTTLER = ['4100', '4800', '4900', '5300'];

// export function isGenAiAllowed(bottlerId: string | undefined | null): boolean {
//   if (!bottlerId) return false;
//   return GENAI_REQ_ALLOWED_BOTTLER.includes(bottlerId);
// }

export function jsonCopy<T>(value: T): T {
  return JSON.parse(JSON.stringify(value));
}

export function downloadCsvBase64File(base64Data: string, fileName: string, contentType: string): void {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type: contentType });

  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(blobUrl);
}

export function downloadFile(url: string) {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = url.substr(url.lastIndexOf('/') + 1);
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor); // Remove the anchor element after clicking
}

export function hashStringToColor(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 70%, 60%)`; // Generate an HSL color
  return color;
}

export function createAvatar(name: string): HTMLDivElement {
  const initials = name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();

  const avatar = document.createElement('div');
  avatar.classList.add('avatar');
  avatar.textContent = initials;
  // avatar.style.backgroundColor = hashStringToColor(initials);

  return avatar;
}

export function b64toBlob(b64Data: string, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function downloadZipBase64File(base64Data: string, fileName: string | null): void {
  const anchor = document.createElement('a');
  anchor.href = base64Data;
  anchor.download = fileName || '';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

export function orderItemsByIds<T, K extends keyof T>(ids: T[K][], idkey: K, items: T[]): T[] {
  const idSet = new Set<T[K]>(ids);
  const idToItemMap = new Map<T[K], T>(items.map((item) => [item[idkey], item]));

  const orderedItems: T[] = [];

  for (const id of ids) {
    const item = idToItemMap.get(id);
    if (item) {
      orderedItems.push(item);
    }
  }

  for (const item of items) {
    if (!idSet.has(item[idkey])) {
      orderedItems.push(item);
    }
  }

  return orderedItems;
}

export function formatDate(date: any) {
  const dateObj = new Date(date);
  const formattedDate = dateObj.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  return formattedDate;
}
